/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { TestPlansHubRefreshData } from "TestPlanCommon/Contracts/TestPlan";
import { SuitesActions } from "./SuitesActions";
import { ISuitesAwareState } from "./SuitesContract";
import { SuitesReducer } from "./SuitesReducer";
import { SuitesSaga } from "./SuitesSaga";
import { TestHubRefreshReducer } from "../TestHubRefresh/TestHubRefreshReducer";

export function getSuitesModule(data: TestPlansHubRefreshData): ISagaModule<ISuitesAwareState> {
    const initialActions: ActionsUnion<typeof SuitesActions>[] = [];

    if (data && !data.errorMessage) {
        initialActions.push(SuitesActions.loadInitialTestData());
    }

    return {
        id: "suites",
        reducerMap: {
            testHubRefreshState: TestHubRefreshReducer,
            suiteState: SuitesReducer
        },
        initialActions: initialActions,
        sagas: [SuitesSaga]
    };
}
